// extracted by mini-css-extract-plugin
export default {"cancel":"cancel-92b0","make-bold":"make-bold-3121","left-side-node":"left-side-node-2036"};